import { render, staticRenderFns } from "./DepartList2.vue?vue&type=template&id=4e304b24&scoped=true"
import script from "./DepartList2.vue?vue&type=script&lang=js"
export * from "./DepartList2.vue?vue&type=script&lang=js"
import style0 from "./DepartList2.vue?vue&type=style&index=0&id=4e304b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e304b24",
  null
  
)

export default component.exports